import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import * as mammoth from "mammoth";
import styles from "./index.module.less";
import { Spin } from "antd";
import classNames from "classnames";
import { useLocale } from "@/hooks/useLocale";
const WordPreview = ({ url, locale }) => {
    const { t } = useLocale("attachmentResume", locale);
    const [htmlContent, setHtmlContent] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const langCode = localStorage.getItem("langCode") || "vi";
    const [iframeLoaded, setIframeLoaded] = useState(false); // 新增 iframe 加载状态
    // 根据扩展名判断文件类型
    const isDocFile = url.toLowerCase().endsWith(".doc"); // 网页8]
    useEffect(() => {
        if (isDocFile)
            return; // .doc 文件不需要转换
        const fetchAndConvertWord = async () => {
            try {
                const response = await fetch(url);
                const arrayBuffer = await response.arrayBuffer();
                if (arrayBuffer?.byteLength === 0) {
                    setHtmlContent("");
                }
                else {
                    const result = (await mammoth.convertToHtml({
                        arrayBuffer,
                    }));
                    setHtmlContent(result?.value);
                }
            }
            catch (err) {
                setError(err instanceof Error ? err.message : "Conversion failed");
            }
            finally {
                setLoading(false);
            }
        };
        void (!isDocFile && fetchAndConvertWord());
    }, [url, isDocFile]);
    // 渲染.doc文件
    if (isDocFile) {
        const officeUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}&ui=${langCode}&rs=${langCode}`;
        return (_jsxs("div", { style: { height: "98%" }, children: [!iframeLoaded && (_jsx("div", { className: classNames(styles.pdfLoading), children: _jsxs("div", { className: classNames(styles.pdfLoadingBox), children: [_jsx(Spin, { spinning: true, size: "small" }), _jsx("span", { style: { marginTop: "20px" }, children: t("resumePreviewLoading") })] }) })), _jsx("iframe", { title: "office-preview", src: officeUrl, style: {
                        width: "100%",
                        height: iframeLoaded ? "100%" : "0px",
                        border: "none",
                        zoom: "0.6",
                    }, allowFullScreen: true, onLoad: () => {
                        setLoading(false);
                        setIframeLoaded(true);
                    } })] }));
    }
    //  公共渲染逻辑
    const renderContainer = (content) => (_jsx("div", { style: {
            width: "100%",
            height: "100%",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            overflow: "auto",
            backgroundColor: "#ffffff",
            padding: "10px",
        }, children: content }));
    if (loading)
        return renderContainer(_jsx("div", { className: classNames(styles.pdfLoading), children: _jsxs("div", { className: classNames(styles.pdfLoadingBox), children: [_jsx(Spin, { spinning: true, size: "small" }), _jsx("span", { style: { marginTop: "20px" }, children: t("chat.resumePreviewLoading") })] }) }));
    if (error)
        return renderContainer(_jsxs("div", { style: { color: "red" }, children: ["Error: ", error] }));
    return renderContainer(_jsx("div", { dangerouslySetInnerHTML: { __html: htmlContent } }));
};
export default WordPreview;
